import { takeEvery, put, select } from 'redux-saga/effects';
import companyHomeActions from '../actionTypes/companyHomeActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { GET_COMPANY_HOME_DETAILS, UPDATE_COMPANY } from '../routes';

const getCompanyId = (state) => {
  return state.loginReducer.currentUser.resourceable_id;
};

function* getCompanyHomeDetails({ payload }) {
  const id = yield select(getCompanyId);

  yield put({
    type: API_CALL,
    payload: {
      url: GET_COMPANY_HOME_DETAILS.replace(':id', id),
      method: 'GET',
      data: payload,
    },
    successAction: companyHomeActions.getCompanyHomeDetailsSuccess,
    failureAction: companyHomeActions.getCompanyHomeDetailsFailed,
  });
}

function* updateCompany({ payload }) {
  const { id, company } = payload;

  yield put({
    type: API_CALL,
    payload: {
      url: UPDATE_COMPANY.replace(':id', id),
      method: 'PATCH',
      data: { company },
    },
    successAction: companyHomeActions.updateCompanySuccess,
    failureAction: companyHomeActions.updateCompanyFailed,
  });
}

export default function* watchCompanyHomeDetails() {
  yield takeEvery(
    companyHomeActions.getCompanyHomeDetails, getCompanyHomeDetails
  );
  yield takeEvery(companyHomeActions.updateCompany, updateCompany);
}
